import { OnboardingStatus } from './OnboardingStatus';
import { BackfillStatus } from './BackfillStatus';
import { TeamCategory } from './TeamCategory';
import { TTL_DURATION_SECONDS } from '../../constants';

export class Onboarding {
    public teamName: string;
    public latestPoOnboardTime?: number;
    public latestInvoiceOnboardTime?: number;
    public coupaRuleOnboardTime?: number;
    public lastModifiedTime: number;
    protected coupaRuleActivated: string;
    public onboardingStatus: OnboardingStatus;
    public poBackfillStatus?: BackfillStatus;
    public invoiceBackfillStatus?: BackfillStatus;
    public owner: string;
    public teamCategory: TeamCategory;
    public creationTime: number;
    public ttl: number;

    constructor() {
        this.teamName = '';
        this.lastModifiedTime = Date.now();
        this.coupaRuleActivated = 'N';
        this.ttl = Math.floor(Date.now() / 1000) + TTL_DURATION_SECONDS;
    }

    public get isCoupaRuleActivated(): boolean {
        return this.coupaRuleActivated === 'Y';
    }

    public set isCoupaRuleActivated(value: boolean) {
        this.coupaRuleActivated = value ? 'Y' : 'N';
    }
}
